<template>
   <section class="tf-section bg-st1 pb-mobie-40">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="tf-title st2 m-b60" data-aos="fade-up" data-aos-duration="800">
                        <p class="h8 sub-title">You Are Crucial</p>
                        <h4 class="title m-b17">BUILD WITH US</h4>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="" data-aos="fade-up" data-aos-duration="800">
                            <p>
                                Relsify is a tokenization platform supporting real estate developers with the building of residential and commercial properties by apportioning fractional shares to interested investors on the Blockchain. 
                            </p>
                            <p>
                                With as low as $1 - $50, investors can own a piece of high-quality, high-yield real estate via our marketplace and position for one-time or recurrent profiting. 
                            </p>
                                <p>
                                    We bring you SonsOfHephaestus, a collection of art that resonates with our building journey, community structure, community strength, and one that inspires every builder
                                Experience the Beta version of our Real Estate Marketplace:

                            </p>

                            <a class="tf-button st2 btn-effect" href="https://play.google.com/store/apps/details?id=app.relsify.com">   
                                <span class="boder-fade"></span>                                     
                                <span class="effect">Play Store</span>
                            </a>
                            <a class="tf-button st2 btn-effect" href="https://apps.apple.com/nl/app/relsify/id1622386977">   
                                <span class="boder-fade"></span>                                     
                                <span class="effect">Apple Store</span>
                            </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'RelsifyComponent'
}
</script>

<style>

</style>